export default __webpack_public_path__ + "static/media/carimbo-roxo.9db9fe75.png";